<!--项目报名-->
<template>
  <div>
    <div>
      <van-nav-bar
        :title="'跑兔体育'"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div v-if="url.length > 0">
      <iframe :src="url" style="width: 100%;height: 94vh;"></iframe>
    </div>
    <loading-com></loading-com>
  </div>
</template>

<script>
import ChangeXm from "../commonCom/ChangeXm.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";
export default {
  components: { ChangeXm, LoadingCom, TopItemCom },
  name: "OutPageIndex",

  data() {
    return {
      ssid: "",
      routeValue: "",
      url: ""
    };
  },
  created() {
    this.ssid = this.$route.query.ssid;
    this.url = decodeURIComponent(this.$route.query.zburl);
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
  },
  methods: {
    onTopClickLeft() {
      this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/OutPageIndex/OutPageIndex.vue